import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import DualChoiceToggle from "@/components/toggles/DualChoiceToggle.vue";
let SuccessQuizResult = class SuccessQuizResult extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isAuthor", void 0);
    _defineProperty(this, "quizResultPercentage", void 0);
    _defineProperty(this, "minSuccessRate", void 0);
    _defineProperty(this, "quizSucceededMsg", void 0);
    _defineProperty(this, "quizFailedMsg", void 0);
    _defineProperty(this, "completionMessage", '');
  }
  mounted() {
    if (this.isAuthor) {
      this.completionMessage = this.quizSucceededMsg;
    } else {
      this.completionMessage = this.quizResultPercentage >= this.minSuccessRate ? this.quizSucceededMsg : this.quizFailedMsg;
    }
  }
  updateCompletionMsg(isCompletedChoice) {
    this.completionMessage = isCompletedChoice ? this.quizSucceededMsg : this.quizFailedMsg;
  }
};
__decorate([Prop({
  default: false
})], SuccessQuizResult.prototype, "isAuthor", void 0);
__decorate([Prop({
  default: -1
})], SuccessQuizResult.prototype, "quizResultPercentage", void 0);
__decorate([Prop({
  default: 0
})], SuccessQuizResult.prototype, "minSuccessRate", void 0);
__decorate([Prop({
  default: ''
})], SuccessQuizResult.prototype, "quizSucceededMsg", void 0);
__decorate([Prop({
  default: ''
})], SuccessQuizResult.prototype, "quizFailedMsg", void 0);
SuccessQuizResult = __decorate([Component({
  components: {
    DualChoiceToggle,
    Icon
  }
})], SuccessQuizResult);
export default SuccessQuizResult;